export function throttle(callback: any, delay: any, options: any = {}) {
  let timeout: any
  let lastState: any
  let currentArgs: any
  const throttled = (state: any, ...args: any) => {
    currentArgs = args
    if (timeout && state === lastState) return
    let leading = options.leading

    if (typeof leading === 'function') {
      leading = leading(state, lastState)
    }
    if ((!timeout || state !== lastState) && leading) {
      callback(state, ...currentArgs)
    }
    lastState = state
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      callback(state, ...currentArgs)
      timeout = 0
    }, delay)
  }

  throttled._clear = () => {
    clearTimeout(timeout)
    timeout = null
  }
  return throttled
}

export function deepEqual(val1: any, val2: any) {
  if (val1 === val2) return true
  if (typeof val1 === 'object') {
    for (const key in val1) {
      if (!deepEqual(val1[key], val2[key])) {
        return false
      }
    }
    return true
  }
  return false
}

export async function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export function loadScript(id: string, src: string) {
  return new Promise((resolve, reject) => {
    if (document.getElementById(id)) {
      resolve(0)
      return
    }
    const script = document.createElement('script')
    script.id = id
    script.src = src
    script.async = false // Ensure synchronous execution
    script.onload = () => {
      resolve(1)
    }
    script.onerror = () => {
      reject(new Error(`Failed to load script: ${src}`))
    }
    document.head.appendChild(script)
  })
}

// Function to create a Proxy object that allows case-insensitive access to object keys
export function createCaseInsensitiveObject<T extends object>(obj: T): T & { [key: string]: any } {
  return new Proxy(obj, {
    get(target, prop, receiver) {
      // 1. Return immediately if there is an exact match key (maintain existing type and optimize performance)
      if (prop in target) {
        return Reflect.get(target, prop, receiver)
      }

      // 2. Handle non-string keys (Symbol, etc.) as is
      if (typeof prop !== 'string') {
        return Reflect.get(target, prop, receiver)
      }

      // 3. Find key ignoring case
      const lowerProp = prop.toLowerCase()
      const foundKey = Object.keys(target).find((k) => k.toLowerCase() === lowerProp)

      if (foundKey) {
        return Reflect.get(target, foundKey, receiver)
      }

      return undefined
    },
  }) as T & { [key: string]: any }
}
